import { useMemo } from "react";
import { z } from "zod";
import { useTeams } from "@/api/Patients";
import type { ShiftsWithContents } from "@/api/Shifts";
import { useSelectedFilter } from "./useSelectedFilter";

export const applyTeamFilter = (
  data: ShiftsWithContents,
  selected: ReadonlySet<number>,
  allSelected: boolean,
): ShiftsWithContents => {
  if (allSelected) {
    return data;
  }
  const matches = ({ shift }: { shift: { team?: { id: number } | null } }) =>
    !shift.team || selected.has(shift.team.id);
  return {
    before: data.before.filter(matches),
    relevant: data.relevant.filter(matches),
    after: data.after.filter(matches),
  };
};

const selectedTeamsSchema = z.array(z.number());

export const useTeamFilter = () => {
  const { data: enabledTeams } = useTeams();
  const enabledIds = useMemo(
    () => enabledTeams?.map((t) => t.id),
    [enabledTeams],
  );
  return useSelectedFilter({
    storageKey: "planning-selected-teams",
    schema: selectedTeamsSchema,
    enabledIds,
  });
};
